import { render, staticRenderFns } from "./manageSystem.vue?vue&type=template&id=167b8ef1&scoped=true"
import script from "./manageSystem.vue?vue&type=script&lang=js"
export * from "./manageSystem.vue?vue&type=script&lang=js"
import style0 from "./manageSystem.vue?vue&type=style&index=0&id=167b8ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b8ef1",
  null
  
)

export default component.exports